/* import __COLOCATED_TEMPLATE__ from './add-ach-flow.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import { success } from 'client-portal/utils/banners';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';

export default class SiteBillingPaymentInstrumentPaymentModalCheckoutAddAchFlow extends Component {
  @service billingModals;
  @service paymentInstrumentModals;
  @service stripeAch;
  @service intl;

  @tracked newAchAccount = null;

  constructor() {
    super(...arguments);

    this.newAchAccount = this.stripeAch.createAchAccount();
  }

  get actionsDisabled() {
    return (
      this.stripeAch.addAchPaymentMethodTask.isRunning || this.paymentInstrumentModals.isPersisting
    );
  }

  @action
  exitAddingAch() {
    if (this.newAchAccount?.isNew) {
      this.newAchAccount.deleteRecord();
    }

    this.args.onExit();
  }

  @action
  handleAchSaved(savedAchAccount) {
    let { stripeAchBankAccounts } = this.billingModals.client;

    if (!stripeAchBankAccounts.find(({ id }) => id === savedAchAccount.id)) {
      stripeAchBankAccounts.push(savedAchAccount);
    }

    this.newAchAccount = null;
    this.paymentInstrumentModals.setPaymentInstrument(this.args.model, savedAchAccount);

    this.args.onExit();
    success({ title: this.intl.t('billing.paymentMethods.achAccountAdded') });
  }
}
